// src/svg/SVGCartEmpty.tsx
import React from "react";
var SVGCartEmpty = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    id: "empty-boi_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1019.8 988.1",
    ...props
  },
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".empty-boi_svg__cls-3{fill:#b3a9fc}.empty-boi_svg__cls-10{fill:#e9e9ff}.empty-boi_svg__cls-11{fill:#2ecccc}")),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M959.47 570.36a436.82 436.82 0 01-84.8 259.4c-3 4-6 8-9.1 12h-690.2c-3.1-4-6.1-8-9.1-12a437.27 437.27 0 01-84.8-259.4c0-242.4 196.5-439 439-439s439 196.5 439 439z",
      fill: "#f8f8ff"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M838.17 563c0 111.9-57.9 210.3-145.4 266.8-6.6 4.2-13.3 8.2-20.2 12h-303.5c-6.9-3.8-13.6-7.8-20.2-12-87.5-56.5-145.4-154.9-145.4-266.8 0-175.3 142.1-317.3 317.3-317.3 175.4-.04 317.4 142.06 317.4 317.3z",
      fill: "#f0f0ff"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "empty-boi_svg__cls-3",
      d: "M614.47 285.26a24.8 24.8 0 1124.8-24.8 24.82 24.82 0 01-24.8 24.8zm0-38.6a13.8 13.8 0 1013.8 13.8 13.81 13.81 0 00-13.8-13.8zM133 504.66a17.9 17.9 0 1117.9-17.9 17.92 17.92 0 01-17.9 17.9zm0-26.8a8.9 8.9 0 108.9 8.9 8.91 8.91 0 00-8.9-8.9z"
    }
  ),
  /* @__PURE__ */ React.createElement("circle", { className: "empty-boi_svg__cls-3", cx: 393.87, cy: 189.06, r: 10.1 }),
  /* @__PURE__ */ React.createElement(
    "ellipse",
    {
      className: "empty-boi_svg__cls-3",
      cx: 894.97,
      cy: 439.76,
      rx: 10.05,
      ry: 10.13,
      transform: "rotate(-44.99 894.945 439.76)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "ellipse",
    {
      className: "empty-boi_svg__cls-3",
      cx: 407.99,
      cy: 494.05,
      rx: 10.05,
      ry: 10.13,
      transform: "rotate(-44.99 407.983 494.05)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "empty-boi_svg__cls-3",
      d: "M847.37 577.06l4.8-4.8a7.67 7.67 0 000-10.7 7.57 7.57 0 00-10.7 0l-4.8 4.8-4.8-4.8a7.57 7.57 0 00-10.7 10.7l4.8 4.8-4.8 4.8a7.57 7.57 0 1010.7 10.7l4.8-4.8 4.8 4.8a7.57 7.57 0 0010.7-10.7zM282.61 365.87l4.8-4.8a7.67 7.67 0 000-10.7 7.57 7.57 0 00-10.7 0l-4.8 4.8-4.8-4.8a7.57 7.57 0 00-10.7 10.7l4.8 4.8-4.8 4.8a7.57 7.57 0 0010.7 10.7l4.8-4.8 4.8 4.8a7.57 7.57 0 0010.7-10.7zm390.59 54.69h4.3a4.8 4.8 0 000-9.6h-4.3v-4.3a4.8 4.8 0 00-9.6 0V411h-4.3a4.8 4.8 0 100 9.6h4.3v4.3a4.8 4.8 0 009.6 0zm-445.97 252.8h4.3a4.8 4.8 0 000-9.6h-4.3v-4.3a4.8 4.8 0 10-9.6 0v4.3h-4.3a4.8 4.8 0 000 9.6h4.3v4.3a4.8 4.8 0 109.6 0z"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M915.67 835.76a5.64 5.64 0 01-1.8 4.2 6 6 0 01-4.2 1.8h-760.6a6 6 0 01-6-6 5.64 5.64 0 011.8-4.2 6 6 0 014.2-1.8h760.6a6 6 0 016 6z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M425.36 603.2h-.05zm15.27 0zm0 0zm-15.27 0h-.05zm15.27 0z",
      fill: "#f3e8d7"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M425.36 603.2h-.05zm15.27 0z", fill: "#e5d8c6" }),
  /* @__PURE__ */ React.createElement("path", { d: "M425.36 603.2h-.05zm15.27 0z", fill: "#d8c9b6" }),
  /* @__PURE__ */ React.createElement("path", { d: "M425.36 603.2h-.05zm15.27 0z", fill: "#33d8dd" }),
  /* @__PURE__ */ React.createElement("path", { d: "M756.89 592.45a11.69 11.69 0 00-8.67-3.85h-455.9a11.71 11.71 0 00-11.64 12.86c4.8 47.95 25.79 136.75 112.45 192.74l.18.12v24a23.45 23.45 0 0023.42 23.42H623.9a23.45 23.45 0 0023.42-23.42v-24.05l.18-.12c43.31-28 75-67.19 94.23-116.45 2.39-6.14 4.61-12.51 6.59-18.9 1.6-5.19 3.06-10.47 4.35-15.71a296.7 296.7 0 007.19-41.63 11.69 11.69 0 00-2.97-9.01zM633.22 818.34a9.33 9.33 0 01-9.32 9.32H416.73a9.33 9.33 0 01-9.32-9.32v-20.92h17.45a7 7 0 000-14h-21.94a1.92 1.92 0 01-.5-.08 1.15 1.15 0 01-.4-.19c-81.36-51.86-101.94-135-107-179.88l-.06-.56h204.88v.1h245.6l-.05.44a283.93 283.93 0 01-6.5 36.44c-1.26 5.08-2.66 10.1-4.15 14.93-1.82 5.93-3.92 12-6.25 17.93-18.29 46.93-48.59 84.12-90 110.54l-.09.06-.23.09a1.78 1.78 0 01-.48.08h-45.43l-.12.1H459.76a7 7 0 000 14h173.46z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M693.23 602.7h-.47v.07h52.68l-.05.44a283.93 283.93 0 01-6.5 36.44c-1.26 5.08-2.66 10.1-4.15 14.93-1.82 5.93-3.92 12-6.25 17.93-18.29 46.93-48.59 84.12-90 110.54l-.09.06-.23.09a1.78 1.78 0 01-.48.08h-45.43l-.12.1h45.48a1.78 1.78 0 00.52-.09l.22-.08.12-.08c41.47-26.43 71.77-63.64 90.08-110.59 2.32-6 4.43-12 6.25-17.93 1.49-4.83 2.89-9.85 4.14-14.94a283.8 283.8 0 006.51-36.45l.06-.55z",
      fill: "#23b5b1"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "empty-boi_svg__cls-10",
      d: "M745.44 602.8l-.05.44a283.93 283.93 0 01-6.5 36.44c-1.26 5.08-2.66 10.1-4.15 14.93-1.82 5.93-3.92 12-6.25 17.93-18.29 46.93-48.59 84.12-90 110.54l-.09.06-.23.09a1.78 1.78 0 01-.48.08h-45.43l-.12.1h-.78l1-.88c9.07-7.67 55.68-48.93 82.32-108.52a212 212 0 0015.69-50.46v-.16a179.47 179.47 0 002.28-20.19v-.4z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "empty-boi_svg__cls-11",
      d: "M425.36 603.2h-.05zm15.27 0zm252.63-.5l-.01.1H499.86l-.02-.1h193.42z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M499.86 602.8v-.1H295l.06.56c5 44.92 25.61 128 107 179.88a1.15 1.15 0 00.4.19 1.92 1.92 0 00.5.08h21.94a7 7 0 010 14h-17.49v20.92a9.33 9.33 0 009.32 9.32H623.9a9.33 9.33 0 009.32-9.32v-20.91H459.76a7 7 0 010-14h131.6l1-.88c9.07-7.67 55.68-48.93 82.32-108.52a212 212 0 0015.69-50.46v-.16a179.47 179.47 0 002.28-20.19v-.4zm-74.5.42h-.05.05zm15.25 0z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      className: "empty-boi_svg__cls-10",
      d: "M591.36 827.66h32.54a9.33 9.33 0 009.32-9.32v-20.92h-41.86z"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { className: "empty-boi_svg__cls-11", d: "M425.31 663.53h.05zm15.32 0z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M451.27 707.88c0-13.2-13.4-23.9-30-23.9s-30 10.7-30 23.9 13.4 23.9 30 23.9 30-10.78 30-23.9zm198 0c0-13.2-13.4-23.9-30-23.9s-30 10.7-30 23.9 13.4 23.9 30 23.9 30-10.78 30-23.9z",
      fill: "#d1d1ed"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M413.47 710.78a6.75 6.75 0 01-1.4-.2 5.45 5.45 0 01-2.4-9.2l7.1-7.1a5.37 5.37 0 013.8-1.5 5.7 5.7 0 013.9 1.6 5.59 5.59 0 01.1 7.7l-7.1 7.1a6.14 6.14 0 01-4 1.6zm28.4 0a6.75 6.75 0 01-1.4-.2 5.45 5.45 0 01-2.4-9.2l7.1-7.1a5.37 5.37 0 013.8-1.5 5.7 5.7 0 013.9 1.6 5.59 5.59 0 01.1 7.7l-7.1 7.1a6.14 6.14 0 01-4 1.6zm184.4-.1a5.37 5.37 0 01-3.8-1.5l-7.1-7.1a5.46 5.46 0 01.1-7.6 5.52 5.52 0 013.9-1.6 5.37 5.37 0 013.8 1.5l7.1 7.1a5.46 5.46 0 01-.1 7.6 5.52 5.52 0 01-3.9 1.6zm-28.27 0a5.37 5.37 0 01-3.8-1.5l-7.1-7.1a5.46 5.46 0 01.1-7.6 5.52 5.52 0 013.9-1.6 5.37 5.37 0 013.8 1.5l7.1 7.1a5.46 5.46 0 01-.1 7.6 5.89 5.89 0 01-3.9 1.6zm-78.08 18.72a21.52 21.52 0 1121.52-21.52 21.54 21.54 0 01-21.52 21.52zm0-33a11.52 11.52 0 1011.52 11.52 11.54 11.54 0 00-11.52-11.56z" }),
  /* @__PURE__ */ React.createElement("circle", { cx: 579.96, cy: 661.26, r: 12.4 }),
  /* @__PURE__ */ React.createElement("circle", { cx: 454.46, cy: 661.26, r: 12.4 })
);

export {
  SVGCartEmpty
};
